export default __webpack_public_path__ + "static/media/RC_folks.9154349a.jpg";